module.exports = __webpack_public_path__ + "img/fd3ded7.jpg";